var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c("gg-modal", {
    attrs: {
      "is-active": _vm.modal,
      "max-width": "400"
    },
    scopedSlots: _vm._u([
      {
        key: "title",
        fn: function fn() {
          return [_vm._v(" Your session is about to end. ")]
        },
        proxy: true
      },
      {
        key: "body",
        fn: function fn() {
          return [
            _vm._v(
              " You’ve been inactive for a while. For your security, we’ll automatically sign you out in approximately 1 minute. You may choose “stay signed in” to continue or sign out if you’re done. "
            )
          ]
        },
        proxy: true
      },
      {
        key: "actions",
        fn: function fn() {
          return [
            _c(
              "gg-btn",
              {
                attrs: {
                  secondary: "",
                  color: "red"
                },
                on: {
                  click: _vm.logOut
                }
              },
              [_vm._v(" Sign Out ")]
            ),
            _c(
              "gg-btn",
              {
                attrs: {
                  primary: ""
                },
                on: {
                  click: _vm.closeModal
                }
              },
              [_vm._v(" Stay Signed in ")]
            )
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }